export default "__VITE_ASSET__B8ZAtMyb__"